import React from 'react';
import useStyles from './styles';
import { Breadcrumbs, Chip, Tooltip } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import clsx from 'clsx';
import { useHistory } from "react-router-dom";

const BreadcrumbsCustom = ({ breadcrumbsData }) => {
    const classes = useStyles();
    const histoty = useHistory()

    return (
        <>
            <Breadcrumbs maxItems={2} classes={{ separator: classes.separator, ol: classes.ol }} separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                {breadcrumbsData.map((item, idx) => {
                    if (item.href !== '') {
                        return (
                            <Tooltip key={idx} title={item.text ? item.text : ''}>
                                <Chip
                                    key={idx}
                                    classes={{ root: classes.root }}
                                    onClick={() => histoty.push(`${item.href}`)}
                                    label={item.text}
                                />
                            </Tooltip>
                        )
                    } else {
                        return (
                            <Tooltip key={idx} title={item.text ? item.text : ''}>
                                <Chip
                                    classes={{
                                        root: classes.root,
                                        label: item.text && item.text.length > 18 ? classes.activeRunText : classes.labelActive,
                                    }}
                                    className={clsx(
                                        classes.active,
                                        item.type && item.type === 'Survey' && classes.activeLight
                                    )}
                                    label={item.text}
                                />
                            </Tooltip>
                        )
                    }
                })}
            </Breadcrumbs>
        </>
    )
}

export default BreadcrumbsCustom